import { render, staticRenderFns } from "./shaicha.vue?vue&type=template&id=64977080&scoped=true"
import script from "./shaicha.vue?vue&type=script&lang=ts"
export * from "./shaicha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64977080",
  null
  
)

export default component.exports